import { Locale } from '@finxone-platform/shared/enums';
import {
  PushNotificationMappingType,
  PushNotificationsSubGroup,
} from '@finxone-platform/shared/sys-config-types';

export const defaultPushNotificationsMapping: PushNotificationMappingType = {
  [Locale.en_GB]: {
    push: {
      [PushNotificationsSubGroup.TRANSACTIONS_ALERTS]: [],
    },
  },
};

// use as a common type for returned values, add new values as the list increases
type RequestedSubgroupEnumType = typeof PushNotificationsSubGroup;

export const localeToSubgroupMap = new Map<Locale, RequestedSubgroupEnumType>([
  [Locale.en_GB, PushNotificationsSubGroup],
]);
